import * as React from "react";
import styled from "styled-components/native";

import useFetchCurrentUser from "../../hooks/useFetchCurrentUser";
import { Text, Space, rounded, Info } from "../../styled-component";
import { Theme } from "../../styles";
import Layout from "./Layout";

const Image = styled.Image`
  ${rounded};
`;

const size = Theme.spacing * 5;

function CurrentUser({ children }: React.PropsWithChildren<{}>) {
  const { data: currentUser } = useFetchCurrentUser();
  const { name, picture } = currentUser?.profile || {};
  const sizeStyles = { width: size, height: size };

  return (
    <Layout.Row alignItems="center">
      {picture ? (
        <Image style={sizeStyles} source={{ uri: picture }} />
      ) : (
        <Info style={sizeStyles} />
      )}

      <Space />

      <Layout.Column>
        <Text>{name || "|"}</Text>

        {children}
      </Layout.Column>
    </Layout.Row>
  );
}

export default CurrentUser;
